import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Material } from '../material';
import { Router } from '@angular/router';
import { ShoppingcartService } from '../shoppingcart.service';
import { LoadingService } from '../loading-spinner/loading.service';

@Component({
    selector: 'pw-removepackagepopup',
    templateUrl: './removepackagepopup.component.html',
    styleUrls: ['./removepackagepopup.component.scss']
})
export class RemovepackagepopupComponent {
    selectedAlign: 'start' | 'center' | 'end';

    constructor(
        private _loadingService: LoadingService,
        private _shoppingCartService: ShoppingcartService,
        private _router: Router,
        @Inject(MAT_DIALOG_DATA) public material: Material,
        private _dialog: MatDialog
    ) {
        this.selectedAlign = 'end';
    }

    closeDialog() {
        this._dialog.closeAll();
    }

    removeItem() {
        const totalPrice: number = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        if (totalPrice > 0) {
            if (!this.material.packageName) {

                this.material.quantityOfSupply! += this.material.quantity!;
                this.material.quantity = 0;
                this._shoppingCartService.removeItem(this.material);
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                this.closeDialog();
                window.location.reload();
            } else if (this.material.packageName) {
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                materials.forEach((materialObject) => {
                    if (materialObject.packageName === this.material.packageName) {

                        materialObject.quantityOfSupply! += materialObject.quantity!;
                        materialObject.quantity = 0;
                        this._shoppingCartService.removeItem(materialObject);
                        const materialList = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                        this.closeDialog();
                        window.location.reload();
                    }
                });
            }

        }
    }
}
